import sound from './portal.wav';export default sound;